// extracted by mini-css-extract-plugin
export var createdDate = "_mu-1";
export var divider = "_mu-2";
export var headerDivider = "_mu-3";
export var messagesCard = "_mu-0";
export var messagesContainer = "_mu-6";
export var messagesContainerWrapper = "_mu-4";
export var showLeftPanelButton = "_mu-8";
export var topButtons = "_mu-7";
export var withPadding = "_mu-5";